// filepath: src/apps/policymaker/pages/PIR/page/PIRCollectionRequests.jsx
import React from 'react';
import {Stack} from '@mui/material';
import PIRCollectionRequestsHeader from './PIRCollectionRequestsHeader';
import PIRCollectionRequestsList from './PIRCollectionRequestsList';

export default function PIRCollectionRequests({pirId, headerActions = null, headerTitle = 'Collection requests'}) {
    return (
        <Stack spacing={2}>
            <PIRCollectionRequestsHeader title={headerTitle} actions={headerActions} pirId={pirId}/>
            <PIRCollectionRequestsList pirId={pirId}/>
        </Stack>
    );
}
